// extracted by mini-css-extract-plugin
export default {"container":"policy_info_section_container__GHwa0","title":"policy_info_section_title__-S--h"};